import ReactSelect, { createFilter, type GroupBase } from 'react-select';

import classNames from 'classnames';

import type { SelectProps } from './types/select.props';

import CheckboxOption from './components/checkbox-option.component';
import GroupHeading from './components/group-heading.component';
import Group from './components/group.component';
import MultiValue from './components/multi-value.component';
import Option from './components/option.component';
import { useSelectConfiguration } from './hooks/select-configuration.hook';

import cssClasses from './select.module.css';

export function Select<
  IsMulti extends boolean = false,
  Option = unknown,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  className,
  components,
  isClearable,
  isFixed,
  maxVisible,
  onChange,
  options,
  useCheckboxOption = false,
  value,
  ...props
}: SelectProps<IsMulti, Option, Group>) {
  const { changed, clearable } = useSelectConfiguration({
    isClearable,
    isFixed,
    onChange,
    options,
    value,
  });

  return (
    <ReactSelect
      {...props}
      className={classNames(cssClasses.hspSelect, className)}
      classNamePrefix="hsp-select"
      components={{
        Group,
        GroupHeading,
        MultiValue,
        Option: useCheckboxOption ? CheckboxOption : Option,
        ...components,
      }}
      filterOption={createFilter({ ignoreAccents: false })}
      isClearable={clearable}
      isFixed={isFixed}
      maxVisible={maxVisible}
      menuPlacement="auto"
      menuShouldScrollIntoView
      onChange={changed}
      options={options}
      value={value}
    />
  );
}
